import { get, post, put, remove } from '@/utils/request'
import { TDataPackageTemplateDTO, TDataPackageTemplateViewDTO } from '../template/package/type'

interface ResponseData<T> {
  code: number
  data: T
  message?: string
}

const baseUrl = '/cmp-doc/tmpl/dataPkg'
const baseUrlView = '/cmp-doc/tmpl/dataPkgView'

// 获取资料包模板列表
export const getDataPackageTemplateList = (params: any): Promise<any> => {
  return get(`${baseUrl}/list`, params)
}

// 新增资料包模板
export const addDataPackageTemplate = (data: TDataPackageTemplateDTO): Promise<any> => {
  return post(`${baseUrl}/add`, data)
}

// 更新资料包模板
// export const updateDataPackageTemplate = (id: string, data: Partial<TDataPackageTemplateDTO>): Promise<any> => {
export const updateDataPackageTemplate = (id: string, data: any): Promise<any> => {
  return put(`${baseUrl}/${id}`, data)
}

// 删除资料包模板
export const deleteDataPackageTemplate = (id: string): Promise<any> => {
  return remove(`${baseUrl}/${id}`)
}

// 获取资料包详情
export const getDataPackageDetail = (id: string): Promise<any> => {
  return get(`${baseUrl}/${id}`)
}

// 启用/禁用资料包模板
export const toggleDataPackageTemplateStatus = (id: string, enable: boolean): Promise<any> => {
  return put(`${baseUrl}/toggle-enable/${id}?enable=${enable}`)
}

// 设置默认资料包模板
export const setDefaultDataPackageTemplate = (id: string, isDefault: boolean): Promise<any> => {
  return put(`${baseUrl}/set-default/${id}?default=${isDefault}`)
}

// 获取视图列表
export const getViewList = (templateId: string): Promise<any> => {
  return get(`${baseUrlView}/list-view?dataPackageTemplateId=${templateId}`)
}

// 获取视图详情
export const getViewDetail = (viewId: any): Promise<any> => {
  return get(`${baseUrlView}/${viewId}`)
}

// 新增视图
export const addView = (templateId: string, data: Partial<TDataPackageTemplateViewDTO>): Promise<any> => {
  return post(`${baseUrlView}/add`, data)
}

// 更新视图
export const updateView = (templateId: string, viewId: string, data: Partial<TDataPackageTemplateViewDTO>): Promise<any> => {
  return put(`${baseUrl}/${templateId}/views/${viewId}`, data)
}

// 删除视图
export const deleteView = (viewId: string): Promise<any> => {
  return remove(`${baseUrlView}/${viewId}`)
}

// 更新视图排序
export const updateViewSort = (templateId: string, data: { viewIds: string[] }): Promise<any> => {
  return put(`${baseUrl}/${templateId}/views/sort`, data)
}